export default __webpack_public_path__ + "static/media/numbers.6b496456.png";